import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  measurementVideos: [],
  measurementFullVideo: {},
};

const measurementSlice = createSlice({
  name: "measurement",
  initialState,
  reducers: {
    setMeasurementVideos: (state, action) => {
      state.measurementVideos = action.payload;
    },
    addMeasurementVideo: (state, action) => {
      state.measurementVideos.push(action.payload);
    },
    removeMeasurementVideo: (state, action) => {
      state.measurementVideos = state.measurementVideos.filter(
        (item) => item.id !== action.payload,
      );
    },
    setMeasurementFullVideo: (state, action) => {
      state.measurementFullVideo = action.payload;
    },
  },
});

export const {
  setMeasurementVideos,
  addMeasurementVideo,
  removeMeasurementVideo,
  setMeasurementFullVideo,
} = measurementSlice.actions;

export default measurementSlice.reducer;
